import type { FieldDefinition } from '../../../../utils/fieldDefinitionUtils';

export const unsettledTransactionsFieldDefinitions: Record<string, FieldDefinition> = {
  // Grouping columns
  marketAccount: {
    title: 'Market Account',
  },
  batchId: {
    title: 'Batch ID / Unbatched',
  },
  settlementDue: {
    title: 'Settlement Due',
  },
  transactionType: {
    title: 'Transaction Type',
    tooltip:
      'Granular transaction type from the settlement report (TransactionType), not the settlement event type (Trade or Asset Transaction).',
  },
  settlementLeg: {
    title: 'Settlement Leg',
    tooltip: 'Identifies whether the settlement is for the base asset or the quote asset of the trade.',
  },

  // Data columns
  symbol: {
    title: 'Symbol / Asset',
    tooltip: 'The instrument that was transacted',
  },
  status: {
    title: 'Status',
    tooltip: 'The current state of settlement of the transaction',
  },
  payer: {
    title: 'Payer',
    tooltip: 'The party delivering the asset or funds for this settlement leg.',
  },
  receiver: {
    title: 'Receiver',
    tooltip: 'The party receiving the asset or funds for this settlement leg.',
  },
  side: {
    title: 'Side',
    tooltip: 'Indicates whether the original order was a buy or a sell.',
  },
  quantity: {
    title: 'Quantity',
    tooltip: 'The amount of the base asset being transacted.',
  },
  amount: {
    title: 'Counter Amount',
    tooltip: 'The amount of the counter (quote) asset being transacted.',
  },
  subAccount: {
    title: 'Sub Account',
    tooltip: 'The sub account the trade was allocated to.',
  },
  transactTime: {
    title: 'Transact Time',
    tooltip: 'The timestamp when the transaction was executed.',
  },
  eventId: {
    title: 'Event ID',
    tooltip: 'The unique identifier of this settlement event.',
  },
  tradeId: {
    title: 'Trade ID',
    tooltip: 'The unique identifier of the executed trade, when this settlement event represents a trade.',
  },
  orderId: {
    title: 'Order ID',
    tooltip: 'The identifier of the original order that generated a trade.',
  },
  dealId: {
    title: 'Deal ID',
    tooltip: 'The identifier of the deal that generated this settlement event.',
  },
  externalTradeId: {
    title: 'External Trade ID',
    tooltip: 'The unique identifier assigned to this transaction by external venue.',
  },
  filledPrice: {
    title: 'Filled Price',
    tooltip: 'The execution price per instrument unit of the trade.',
  },
  eventType: {
    title: 'Event Type',
    tooltip: 'Settlement event type (Trade or Asset Transaction), not the granular Transaction Type.',
  },
  settleBatchId: {
    title: 'Batch ID / Unbatched',
    tooltip: 'The settlement batch identifier or unbatched status',
  },
  counterparty: {
    title: 'Counterparty',
    tooltip: 'The counterparty involved in the transaction.',
  },
  tradeDateEOD: {
    title: 'Trade Date EOD',
    tooltip: "The end-of-day cutoff for the trade's business date.",
  },
};
